import "./styles/DropdownResults.scss";

interface IProps {
    children:
        | string
        | JSX.Element
        | JSX.Element[]
        | (JSX.Element | undefined | null)[];
}

const DropdownResults = ({ children }: IProps) => {
    return <div className="dropdown__results">{children}</div>;
};
export default DropdownResults;
